import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

const KEY = "tml_consent";

export default function ConsentBanner() {
  const { settings } = useSite();
  const [consent, setConsent] = useState(() => localStorage.getItem(KEY));
  const loc = useLocation();
  const enabled = settings?.analytics?.enabled !== false;

  useEffect(() => {
    if (enabled && consent === "granted") api.post("/analytics/track", { path: loc.pathname }).catch(() => {});
  }, [loc.pathname, consent, enabled]);

  if (!enabled || consent) return null;
  const choose = (v) => { localStorage.setItem(KEY, v); setConsent(v); };
  return (
    <div className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] glass rounded-xl p-5 shadow-2xl" role="dialog" aria-label="Cookie consent" data-testid="consent-banner">
      <p className="text-sm text-slate-200 leading-relaxed">We use privacy-friendly, first-party analytics (no ads, no third-party trackers) to understand which pages help people most. May we count your visit?</p>
      <div className="flex gap-3 mt-4">
        <button onClick={() => choose("granted")} className="btn-gold !py-2 !px-5" data-testid="consent-accept-btn">Allow</button>
        <button onClick={() => choose("denied")} className="btn-outline !py-2 !px-5" data-testid="consent-decline-btn">Decline</button>
      </div>
    </div>
  );
}
